var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnterCarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_575",
    "data-name": "Rectangle 575",
    width: 89,
    height: 89,
    transform: "translate(0 0)",
    fill: "#003383"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10513",
    "data-name": "Group 10513",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10347",
    "data-name": "Group 10347",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27728",
    "data-name": "Path 27728",
    d: "M68.234,89a9.379,9.379,0,0,1-8.9-8.9V77.134H29.667V80.1a8.913,8.913,0,0,1-8.9,8.9,9.379,9.379,0,0,1-8.9-8.9V77.134H8.9a8.607,8.607,0,0,1-8.9-8.9V44.5a8.914,8.914,0,0,1,6.93-8.679l3.805-23.267A15.1,15.1,0,0,1,25.529,0H62.886A15.079,15.079,0,0,1,77.664,12.46l3.805,23.267A9.463,9.463,0,0,1,89,44.5V68.234a8.607,8.607,0,0,1-8.9,8.9H77.134V80.1a8.913,8.913,0,0,1-8.9,8.9M26.7,71.2H62.3a2.968,2.968,0,0,1,2.967,2.967V80.1a3.474,3.474,0,0,0,2.967,2.967A2.973,2.973,0,0,0,71.2,80.1V74.167A2.968,2.968,0,0,1,74.167,71.2H80.1a2.675,2.675,0,0,0,2.967-2.967V44.5A3.474,3.474,0,0,0,80.1,41.533H78.929a2.974,2.974,0,0,1-2.935-2.484L71.825,13.512a9.058,9.058,0,0,0-8.94-7.579H25.529a9.09,9.09,0,0,0-8.955,7.682L12.413,39.049a2.96,2.96,0,0,1-2.927,2.484c-2.413,0-3.552,1.543-3.552,2.967V68.234A2.675,2.675,0,0,0,8.9,71.2h5.933A2.968,2.968,0,0,1,17.8,74.167V80.1a3.474,3.474,0,0,0,2.967,2.967A2.978,2.978,0,0,0,23.733,80.1V74.167A2.968,2.968,0,0,1,26.7,71.2m41.533-5.933a8.607,8.607,0,0,1-8.9-8.9,8.9,8.9,0,1,1,17.8,0,8.913,8.913,0,0,1-8.9,8.9m0-11.867a2.675,2.675,0,0,0-2.967,2.967,2.675,2.675,0,0,0,2.967,2.967A2.973,2.973,0,0,0,71.2,56.367,2.675,2.675,0,0,0,68.234,53.4M20.767,65.267a8.607,8.607,0,0,1-8.9-8.9,8.607,8.607,0,0,1,8.9-8.9,8.607,8.607,0,0,1,8.9,8.9,8.913,8.913,0,0,1-8.9,8.9m0-11.867A2.675,2.675,0,0,0,17.8,56.367a2.675,2.675,0,0,0,2.967,2.967,2.978,2.978,0,0,0,2.967-2.967A2.675,2.675,0,0,0,20.767,53.4m46.3-11.867H21.352a2.966,2.966,0,0,1-2.919-3.481L22.61,14.319a2.963,2.963,0,0,1,2.919-2.452H62.886A2.963,2.963,0,0,1,65.8,14.319l4.177,23.733a2.966,2.966,0,0,1-2.919,3.481M24.888,35.6H63.526L60.4,17.8H28.021Z",
    transform: "translate(0 0)",
    fill: "#003383"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterCarIcon);
export default __webpack_public_path__ + "static/media/enter_car_icon.dc31eedd9e22b8abba67599986c2ad96.svg";
export { ForwardRef as ReactComponent };